import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { COLORS } from 'Components/utils/color/colors';
import { ICONS } from 'Components/utils/icon/icons';
import { t } from 'Src/i18n';
import { makeViewProps } from 'Src/types/view-helpers';
import { Toast } from 'Components/frameworks/toast/Toast';
import { getInsurancesStore } from 'Store/booking/booking.selector';
import { INVALID_INSURANCE } from './insurance.constantes';
import { InsuranceBody } from './InsuranceBody';
import { InsuranceCTA } from './InsuranceCTA';
import { InsuranceFeedback } from './InsuranceFeedback';
type Props = {
  errorMessageCode: string;
  insurance: UpsellInsurance;
  isContinueActionClicked: boolean;
  isLoading: boolean;
  onChange: (insurance: UpsellInsurance, action: string) => void;
  dataTestId?: string;
};
export const Insurance = ({
  errorMessageCode,
  insurance,
  isContinueActionClicked,
  isLoading,
  onChange,
  dataTestId = '',
}: Props) => {
  const [addedInsuranceNow, setAddedInsuranceNow] = useState(false);
  const { id, totalPrice: price } = insurance.pricingInfo;
  const { label } = insurance.productInfo;
  const {
    coverageDescriptions = [],
    attachedDocuments = [],
    shortDescription,
    company,
  } = insurance?.productInfo.insuranceDetails?.find((detail) => detail.id === id) || {};
  let isAdded = false;
  let termsChecked = false;
  let isDeleted = false;
  const insurancesStore = useSelector(getInsurancesStore);

  if (insurancesStore[id]) {
    isAdded = insurancesStore[id].isAdded;
    isDeleted = insurancesStore[id].isDeleted;
    termsChecked = insurancesStore[id].termsChecked;
  }

  const hasJustSubscribedToInsurance = isAdded && !isDeleted && addedInsuranceNow;
  const submittedWithInsuranceWithoutTermsChecked =
    isAdded && !termsChecked && !isDeleted && isContinueActionClicked;
  return (
    <div data-testid={dataTestId}>
      <div className="mb-15">
        <div className="rounded-12 bg-pearl pb-25">
          {!!price && (
            <InsuranceBody
              label={label}
              shortDescription={shortDescription}
              coverageDescriptions={coverageDescriptions}
              company={company}
              price={price}
              dataTestId="insurance-info"
            />
          )}
          <InsuranceCTA
            id={id}
            insurance={insurance}
            isLoading={isLoading}
            onChange={onChange}
            attachedDocuments={attachedDocuments}
            setAddedInsuranceNow={setAddedInsuranceNow}
            dataTestId="insurance-choice"
          />
          {isContinueActionClicked && errorMessageCode === INVALID_INSURANCE && (
            <div className="px-20">
              <InsuranceFeedback
                name="insurance-invalid-error"
                text={t('booking.insurance.errorMessage2')}
                type="error"
              />
            </div>
          )}
          {isContinueActionClicked && (isDeleted || (isAdded && termsChecked)) && (
            <div className="px-20">
              <InsuranceFeedback
                name="insurance-added"
                text={t('booking.insurance.noInsurance')}
                type="notice"
              />
            </div>
          )}
          {submittedWithInsuranceWithoutTermsChecked && (
            <div className="px-20">
              <InsuranceFeedback
                name="insurance-terms-error"
                text={t('booking.insurance.errorMessage3')}
                type="error"
              />
            </div>
          )}
        </div>
      </div>

      {hasJustSubscribedToInsurance && (
        <Toast
          {...makeViewProps<any>({
            color: COLORS.GREEN,
            icon: ICONS.CHECK_OUTLINE,
            label: t('booking.insurance.insuranceTaken'),
            onClose: () => setAddedInsuranceNow(false),
            visible: addedInsuranceNow,
          })}
        />
      )}
    </div>
  );
};
